import { Navigate, useSearchParams } from 'react-router';

/** Legacy route — redirects to Online giving. */
export const HubtelPage = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.toString();
  return <Navigate to={query ? `/payments?${query}` : '/payments'} replace />;
};
